import {
	ChangeDetectionStrategy,
	Component,
	OnInit,
	ViewChild,
} from '@angular/core';
import { MatterFormViewerContainerComponent } from '@components/matter-form-viewer-container/matter-form-viewer-container.component';
import { ICON } from '@core/util/icon';
import { PDFFormType } from '@models/matter-form-data';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ClipboardService } from '@services/clipboard/clipboard.service';
import { SelectedMatterFormsDispatch } from '@state/global/forms/selected-matter-forms.dispatch';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './submit-commercial.hooks';

@Component({
	selector: 'app-submit-commercial',
	templateUrl: './submit-commercial.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SubmitCommercialComponent implements OnInit {
	testHooks = TestHooks;
	public ICON = ICON;
	public finishedRendering: boolean = false;

	@ViewChild(MatterFormViewerContainerComponent)
	matterFormViewerContainer: MatterFormViewerContainerComponent;
	@SelectSnapshot(SelectedMatter.titleInsuranceSelectedForm)
	selectedForm: PDFFormType;

	constructor(
		private clipboard: ClipboardService,
		private selectedMatterFormDispatch: SelectedMatterFormsDispatch,
	) {}

	ngOnInit(): void {
		this.selectedMatterFormDispatch.SelectForm(this.selectedForm);
	}

	copyToClipboard(text: string) {
		this.clipboard.copyText(text, true);
	}

	print() {
		this.matterFormViewerContainer.printInBackground();
	}

	download() {
		this.matterFormViewerContainer.download();
	}

	finishRender() {
		this.finishedRendering = true;
	}
}
